import React from 'react';
import { Button, Text } from 'components';
import Illustration from 'images/illustrations/Checklist.svg';
import { AccountSetupContent, AccountSetupFooter, AccountSetupHeader } from './components';

// TODO: Disable browser back after completing account setup steps

const AccountSetupComplete = () => (
  <AccountSetupContent>
    <AccountSetupHeader data-cy="account-setup-header" title="Account Setup Complete" />
    <img src={Illustration} alt="Account Setup Complete" />
    <Text>Your account is set up and ready to use.</Text>

    <AccountSetupFooter>
      <Button label="Use Kickfin" to="/" data-cy="account-setup-complete-button" />
    </AccountSetupFooter>
  </AccountSetupContent>
);

export default AccountSetupComplete;
